import { gql } from "@apollo/client";

const SETTINGS_FIELDS = `
  autoApproveAfterMinutes
  updatedAt
`;

// Where an order stands in moderation; on orders placed through it only.
export const MODERATION_FIELDS = `
  moderation {
    approvedAt
    approvedBy {
      id
      name
      email
    }
    autoApproveAt
    launchAt
    launchedAt
    launchAttempts
    lastError
    rejectedAt
    rejectedBy {
      id
      name
      email
    }
    rejectReason
  }
`;

export const GET_MODERATION_SETTINGS = gql`
  query getModerationSettings {
    getModerationSettings {
      ${SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_MODERATION_SETTINGS = gql`
  mutation updateModerationSettings($settings: ModerationSettingsInput!) {
    updateModerationSettings(settings: $settings) {
      ${SETTINGS_FIELDS}
    }
  }
`;

export const GET_MODERATION_ORDERS = gql`
  query getModerationOrders {
    getModerationOrders {
      id
      hashId
      status
      orderType
      subtype
      orderPrice
      totalInstalls
      initialDate
      endDate
      createdAt
      app {
        title
        appId
        country
        store
      }
      user {
        id
        email
      }
      ${MODERATION_FIELDS}
    }
  }
`;

// Asked apart from the order page's own query, so an order page still opens
// against a backend that has no moderation yet.
export const GET_ORDER_MODERATION = gql`
  query getOrderModeration($orderType: OrderType, $orderId: Int) {
    getOrderByTypeAndId(orderType: $orderType, orderId: $orderId) {
      hashId
      status
      ${MODERATION_FIELDS}
    }
  }
`;

export const APPROVE_ORDER_MODERATION = gql`
  mutation approveOrderModeration($orderType: OrderType!, $hashId: Int!) {
    approveOrderModeration(orderType: $orderType, hashId: $hashId)
  }
`;

export const REJECT_ORDER_MODERATION = gql`
  mutation rejectOrderModeration(
    $orderType: OrderType!
    $hashId: Int!
    $reason: String
  ) {
    rejectOrderModeration(
      orderType: $orderType
      hashId: $hashId
      reason: $reason
    )
  }
`;

// How a user's orders are moderated: AUTO or MANUAL.
export const GET_USER_ORDER_MODERATION = gql`
  query getUserOrderModeration($userId: Int!) {
    getUserOrderModeration(userId: $userId)
  }
`;

export const SET_USER_ORDER_MODERATION = gql`
  mutation setUserOrderModeration($userId: Int!, $mode: ModerationMode!) {
    setUserOrderModeration(userId: $userId, mode: $mode)
  }
`;

// The users whose orders wait for an admin; everyone else is on auto.
export const GET_MANUAL_MODERATION_USER_IDS = gql`
  query getManualModerationUserIds {
    getManualModerationUserIds
  }
`;
